import { nullToZero, nullToEmptyString, nullToFalse } from "src/app/shared/helpers/shared-zero-to-null.function";
import { RfrMonSaveI } from "./rfr-mon-save.result.int";
import { ExtRfrMonSaveQueryI } from "./rfr-mon-save.query.ext";
import { RfrMonSaveQueryI } from "./rfr-mon-save.query.int";
import { ExtRfrMonSaveI } from "./rfr-mon-save.result.ext";

export const MapRfrMonSave = {
  mapQuery: (int: RfrMonSaveQueryI): ExtRfrMonSaveQueryI => ({
    request: {
      plDefrost: nullToFalse(int.defrost),
      pcRemarks: nullToEmptyString(int.remarks),
      pdTemperature: nullToZero(int.temperature),
      piSeqnr: nullToZero(int.seqNr),
    }
  }),
  mapResult: (_ext: ExtRfrMonSaveI): RfrMonSaveI =>  ({
  }),
};